var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheme1CaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.359,
    height: 9.37,
    viewBox: "0 0 39.359 9.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M1115.879,1960.051a1.989,1.989,0,0,1-1.989,1.989h-35.38a1.989,1.989,0,0,1-1.989-1.989v-.85c0-1.635,2.443-2.021,2.662-2.081l15.117-4.193a7.111,7.111,0,0,1,3.8,0l15.117,4.193c.219.06,2.662.508,2.662,2.081v.85Z",
    transform: "translate(-1076.52 -1952.67)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme1CaretUp);
export default __webpack_public_path__ + "static/media/theme1-caret-up.b386b41f62bae807615c410252af246f.svg";
export { ForwardRef as ReactComponent };